var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    [
      _c(
        "b-row",
        { attrs: { id: "login-container" } },
        [
          _c(
            "b-col",
            {
              attrs: {
                id: "login",
                xl: "6",
                "offset-xl": "3",
                md: "8",
                "offset-md": "2"
              }
            },
            [
              _c(
                "div",
                [
                  _c(
                    "b-form",
                    {
                      staticClass: "form",
                      attrs: { onsubmit: "return false" },
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.validateBeforeSubmit.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _c("h3", { staticClass: "form-header bg-primary" }, [
                        _vm._v("Ellipse Configuration Tool")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-content" },
                        [
                          _c(
                            "b-input-group",
                            { staticClass: "pb-2" },
                            [
                              _c("b-input-group-prepend", [
                                _c(
                                  "div",
                                  {
                                    staticClass: "input-icon-prepend bg-primary"
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      style: { color: "white" },
                                      attrs: {
                                        icon: "user",
                                        transform: "right-11 down-5"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c("b-form-input", {
                                attrs: {
                                  id: "Username",
                                  type: "text",
                                  required: "",
                                  placeholder: "Enter email"
                                },
                                nativeOn: {
                                  keyup: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.submit.apply(null, arguments)
                                  },
                                  change: function($event) {
                                    _vm.success = null
                                  }
                                },
                                model: {
                                  value: _vm.auth.email,
                                  callback: function($$v) {
                                    _vm.$set(_vm.auth, "email", $$v)
                                  },
                                  expression: "auth.email"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-alert",
                            {
                              attrs: { variant: "success", show: _vm.success }
                            },
                            [
                              _vm._v(
                                "An email has been sent to the supplied address with further instructions."
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "6" } },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        variant: "primary",
                                        href: "#",
                                        to: "/login",
                                        block: ""
                                      }
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        style: { color: "white" },
                                        attrs: { icon: "times" }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { md: "6" } },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        variant: "primary",
                                        type: "submit",
                                        block: ""
                                      }
                                    },
                                    [
                                      !_vm.pending
                                        ? _c("font-awesome-icon", {
                                            style: { color: "white" },
                                            attrs: { icon: "check" }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.pending
                                        ? _c("font-awesome-icon", {
                                            style: { color: "white" },
                                            attrs: { icon: "spinner", spin: "" }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass: "pt-5",
                  staticStyle: { "text-align": "center" },
                  attrs: { id: "footer_text" }
                },
                [
                  _c(
                    "svg",
                    {
                      staticStyle: { "padding-bottom": "2px" },
                      attrs: {
                        version: "1.1",
                        id: "Layer_1",
                        xmlns: "&ns_svg;",
                        "xmlns:xlink": "&ns_xlink;",
                        width: "21.56",
                        height: "14.02",
                        viewBox: "0 0 64.705 42.064",
                        overflow: "visible",
                        "enable-background": "new 0 0 64.705 42.064",
                        "xml:space": "preserve"
                      }
                    },
                    [
                      _c("g", [
                        _c("path", {
                          attrs: {
                            d:
                              "M0,42.064L24.258,0l24.258,42.064H40.43L24.24,14.08L8.086,42.064H0z M16.172,42.064l10.793-18.686l4.043,7.014l-2.707,4.658h5.396l4.043,7.014H16.172z M33.68,11.707l6.75-11.672l24.275,42.029H51.223l-4.061-7.014h5.414L40.412,14.063l-2.672,4.658L33.68,11.707z"
                          }
                        })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("b", [_vm._v("Logos Design A/S ")]),
                  _vm._v(
                    " | Nærum Hovedgade 6 | DK-2850 Nærum, Danmark | Tel +45 45 87 78 99\n      "
                  )
                ]
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-30feedca", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30feedca","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./WebApp/components/RequestPasswordReset.vue
// module id = 770
// module chunks = 0